<template>
  <div
    class="build-info-badge"
    data-testid="build-info"
    :title="title"
    :aria-label="t('app.buildInfo.aria')"
  >
    {{ buildInfo.label }}
  </div>
</template>

<script setup lang="ts">
  import { computed } from 'vue'
  import { useI18n } from 'vue-i18n'
  import { buildInfo } from '@/app/buildInfo'

  const { t } = useI18n()

  const title = computed(() => {
    const parts = [
      t('app.buildInfo.version', { version: buildInfo.version }),
      t('app.buildInfo.environment', { environment: buildInfo.environment }),
      t('app.buildInfo.build', { build: buildInfo.buildNumber }),
    ]

    if (buildInfo.buildCommit) {
      parts.push(t('app.buildInfo.commit', { commit: buildInfo.buildCommit }))
    }

    return parts.join('\n')
  })
</script>

<style scoped>
  .build-info-badge {
    position: fixed;
    right: 10px;
    bottom: 8px;
    z-index: 2500;
    max-width: min(420px, calc(100vw - 20px));
    padding: 4px 8px;
    border-radius: 4px;
    background: rgba(255, 255, 255, 0.86);
    color: #4d425a;
    font-size: 0.68rem;
    line-height: 1.3;
    pointer-events: none;
    box-shadow: 0 1px 4px rgba(31, 24, 48, 0.16);
    white-space: nowrap;
  }
</style>
